import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../../../core/services/app-config.service';
import { Store } from '../../../core/services/store.service';
import { ICodeVerificationForm, IRegistrationForm, IUserInfo } from '../../interfaces/auth.interface';
import { AuthApiService } from './auth.api.service';
import { HttpResponse } from '@angular/common/http';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthStoreService } from './auth-store.service';
import { Router } from '@angular/router';
import { OnboardingService } from '../../../onboarding/services/onboarding.service';

@Injectable({
  providedIn: 'root',
})
export class RegistrationStoreService extends Store<number> {
  private token: string;

  public userInfo: IUserInfo = {
    sub: null,
    email: null,
    email_verified: null,
    phone: null,
    phone_verivied: null,
    acceptedRegulations: [],
    given_name: null,
    family_name: null,
    name: null,
    nick: null,
    preferred_username: null,
    customer_id: null,
    roles: [],
    no_consent: null,
    pay_by_link: null,
    pay_by_link_payment_type: null,
    code: null,
  };
  public isAuthenticated: boolean;

  constructor(
    private appConfig: AppConfig,
    private authStore: AuthStoreService,
    private authApi: AuthApiService,
    private router: Router,
    private onboardingStoreService: OnboardingService,
  ) {
    super(1);
  }

  public registerEmail(data: IRegistrationForm): Observable<any> {
    data.email = data.email.toLowerCase();
    this.userInfo.acceptedRegulations = data.acceptedRegulations;

    return this.authApi.registerEmail(data).pipe(
      tap((res: HttpResponse<string>) => {
        this.token = res.headers.get('Auth');
        this.setState(2);
        this.userInfo.email = res.body;
        this.authStore.userInfo = this.userInfo;
      }),
    );
  }

  public goToEmailVerification(email: string, code: string, regulations: string[]): void {
    this.userInfo.acceptedRegulations = regulations.map(value => Number(value).valueOf());
    this.userInfo.email = email;
    this.userInfo.code = code;
    this.authStore.userInfo = this.userInfo;
    this.setState(2);
  }

  public resendVerificationEmail(): Observable<any> {
    return this.authApi.resendVerificationEmail(this.userInfo);
  }

  public verifyEmailCode(code: string) {
    let data: ICodeVerificationForm = {
      code: code,
      state: this.userInfo.email.toLowerCase(),
    };
    return this.authApi.verifyEmailCode(data, this.token).pipe(
      tap((res: HttpResponse<any>) => {
        this.token = res.headers.get('Auth');
        this.setState(3);
        this.userInfo.email_verified = true;
        this.authStore.userInfo = this.userInfo;
      }),
    );
  }

  public addPhone(data: IRegistrationForm): Observable<any> {
    return this.authApi.addPhone(data, this.token).pipe(
      tap((res: HttpResponse<string>) => {
        this.token = res.headers.get('Auth');
        this.setState(4);
        this.userInfo.phone = res.body;
        this.authStore.userInfo = this.userInfo;
      }),
    );
  }

  public resendVerificationSms(): Observable<any> {
    return this.authApi.resendVerificationSms(this.userInfo, this.token);
  }


  public verifyPhoneCode(data: ICodeVerificationForm) {
    data.state = this.userInfo.phone;
    return this.authApi.verifyPhoneCode(data, this.token).pipe(
      tap((res: HttpResponse<any>) => {
        this.token = res.headers.get('Auth');
        this.setState(5);
        this.userInfo.phone_verivied = true;
        this.authStore.userInfo = this.userInfo;
      }),
    );
  }


  public addPassword(data: IRegistrationForm): Observable<any> {
    data.acceptedRegulations = this.userInfo.acceptedRegulations;
    data.email = this.userInfo.email ?  this.userInfo.email.toLowerCase(): this.userInfo.email;
    this.authStore.userInfo = this.userInfo;

    return this.authApi.addPasswordAndSave(data, this.token)
      .pipe(
        switchMap(() => this.processEmailRegistration(data)),
        catchError(
          (error): Observable<any> => {
            console.log(error);
            if (error.status === 404) {
              throw ['VERIFICATION_CODE_INVALID'];
            }
            throw [];
          },
        ),
      );
  }

  public backToFirstStep() {
    if (this.authStore.userInfo !== null && this.authStore.userInfo !== undefined) {
      this.authStore.userInfo.code = null;
    }
    this.setState(1);
  }

  private processEmailRegistration(data: IRegistrationForm): Observable<any> {
    return this.authStore.login({
      email: data.email,
      password: data.password,
      rememberMe: false,
    }).pipe(
      tap((resp) => {
        this.authApi.setInternalTokens(resp);
        if (!this.onboardingStoreService.state) {
          this.onboardingStoreService.init().subscribe();
        }
        return resp;
      }),
      tap(() => {
        this.router.navigate(['/dashboard']);
      }),
      catchError(
        (loginErr): Observable<any> => {
          console.log(loginErr);
          throw loginErr;
        },
      ),
    );
  }

}
